import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { Button } from '../components/ui/button';
import { Home } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
    const { t } = useTranslation();
    return (
        <div className="min-h-[80vh] flex items-center justify-center px-4">
            <div className="text-center">
                <motion.div
                    initial={{ opacity: 0, scale: 0.5 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{
                        duration: 0.8,
                        delay: 0.5,
                        spring: { stiffness: 100 }
                    }}
                    className="mb-8"
                >
                    <div className="text-9xl font-bold text-[#232946]">404</div>
                    <div className="relative">
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="w-32 h-32 bg-[#eebbc3] rounded-full opacity-20 animate-pulse" />
                        </div>
                    </div>
                </motion.div>
                <motion.h1
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.2 }}
                    className="text-2xl md:text-3xl font-bold text-[#232946] mb-4"
                >
                    {t('pages.notFound.title')}
                </motion.h1>
                <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.3 }}
                    className="text-[#8890b3] mb-8"
                >
                    {t('pages.notFound.description')}
                </motion.p>
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.4 }}
                >
                    <Link to="/">
                        <Button className="bg-[#232946] text-white hover:bg-[#121629]">
                            <Home className="w-4 h-4 ml-2" />
                            {t('pages.notFound.back_home_button')}
                        </Button>
                    </Link>
                </motion.div>
            </div>
        </div>
    );
}